import * as React from 'react';

import { VerticalSlider } from '../VerticalSlider';
import { Arrow } from './parts/Arrow';
import { InteriorDecorationItem } from './parts/InteriorDecorationItem';

import * as styles from './styles.css';
import { IInteriorDecorationSchema } from '../../repositories/newbuilding-card/entities/decoration/InteriorDecorationSchema';
import { Section } from '../Section';

interface IInteriorDecorationProps {
  items: IInteriorDecorationSchema[];
  onItemClick(i: number): void;
}

export function InteriorDecoration({ items, onItemClick }: IInteriorDecorationProps) {
  return (
    <Section title="Варианты отделки" id="decorations">
      <VerticalSlider containerClass={styles['slider']} onItemClick={onItemClick} arrow={Arrow}>
        {items.map(({ title, images, shortDescription }) => {
          const { thumbnailUrl, url } = images[0];

          return (
            <InteriorDecorationItem
              key={title}
              title={title}
              imgUrl={thumbnailUrl || url}
              shortDescription={shortDescription}
            />
          );
        })}
      </VerticalSlider>
    </Section>
  );
}
